import * as dict from '../dictionary'
import moment from 'moment';
import {
    Stack, Card, Typography,
    CardContent,
    Button,
    Grid,
    Chip,
    Box,
    styled
} from '@mui/material'
import { StatusTag } from './StatusTag';
import logoNoImage from '../assets/images/no-image.jpg'
import { ImageWithZoom } from './ImageWithZoom';


export const CardDefect = ({ language, version, element, handleClickDetail, tabSelected }) => {
    let defectCode = element.defect_id;
    if (element.defect_code != null && element.defect_code != "") {
        defectCode = element.defect_code;
    }

    const conditionSelectCardDefect = () => {
        if ((version === "fastcare" || version === "fast") && tabSelected === "waiting") {
            return <Card sx={{ minWidth: 275, borderRadius: "10px", boxShadow: "0px 0px 7px 0px #00000040" }}>
                <CardContent >
                    <Grid container spacing={1} direction={"row"} sx={{ justifyContent: "center", alignItems: "center" }} >
                        <Grid item xs={8} >
                            <Stack direction={"column"} spacing={1}>
                                <Stack direction={"row"} alignItems={"center"} spacing={1}>
                                    <Typography fontSize={14} >
                                        {dict.DEFECT_NUMBER_TXT[language]} :
                                    </Typography>
                                    <Typography fontSize={14} fontWeight={"bold"}>
                                        {defectCode}
                                    </Typography>
                                </Stack>
                                <Stack direction={"row"} alignItems={"center"} spacing={1}>
                                    <Typography fontSize={14} >
                                        {dict.TOPIC_JOB_TXT[language]} :
                                    </Typography>
                                    <Typography fontSize={14} fontWeight={"bold"}>
                                        {element.subject}
                                    </Typography>
                                </Stack>
                                <StatusTag code={element?.status} lang={language} version={version} />
                            </Stack>

                        </Grid>
                        <Grid item xs={4}>
                            <BoxHaveImg >
                                <ImageWithZoom
                                    src={element?.photos?.before_photo !== null ? element?.photos?.before_photo?.file_url : logoNoImage}
                                    alt={element?.defect_id}
                                />
                            </BoxHaveImg>
                        </Grid>
                    </Grid>

                    <Stack direction="column"
                        spacing={1}
                    >
                        <Stack direction={"row"} alignItems={"center"} spacing={1}>
                            <Typography variant='subtitle2' >
                                {dict.Date_Create_Defect_TXT[language]} :
                            </Typography>
                            <Typography variant='subtitle2' fontWeight={"bold"} >
                                {moment(element.issue_date).format("DD/MM/YYYY")}
                            </Typography>
                        </Stack>
                        <Stack direction={"row"} alignItems={"center"} spacing={1}>
                            <Typography variant='subtitle2'  >
                                {dict.Date_Appoint_Defect_TXT[language]} :
                            </Typography>
                            <Typography variant='subtitle2' fontWeight={"bold"} >
                                {moment(element.appointment_datetime).format("DD/MM/YYYY HH:MM")}
                            </Typography>
                        </Stack>

                    </Stack>
                    <Stack direction="row"
                        justifyContent="center"
                        mt={2}
                    >
                        <Button size="large"
                            onClick={() => handleClickDetail(element.defect_id)}
                            sx={{ borderRadius: "10px", boxShadow: "0px 0px 7px 0px #00000040", width: "100%" }}>
                            {dict.More_TXT[language]}
                        </Button>
                    </Stack>
                </CardContent>
            </Card>
        }

        if ((version === "fastcare" || version === "fast") && tabSelected === "history") {
            return <Card sx={{ minWidth: 275, borderRadius: "10px", boxShadow: "0px 0px 7px 0px #00000040" }}>
                <CardContent >
                    <Grid container spacing={1} direction={"row"} sx={{ justifyContent: "center", alignItems: "center" }} >
                        <Grid item xs={12} >
                            <Stack direction={"column"} spacing={1}>
                                <Stack direction={"row"} alignItems={"center"} spacing={1}>
                                    <Typography variant="subtitle2" >
                                        {dict.DEFECT_NUMBER_TXT[language]} :
                                    </Typography>
                                    <Typography variant="subtitle2" fontWeight={"bold"}>
                                        {element.defect_id}
                                    </Typography>
                                </Stack>
                                <Stack direction={"row"} alignItems={"center"} spacing={1}>
                                    <Typography variant="subtitle2" >
                                        {dict.TOPIC_JOB_TXT[language]} :
                                    </Typography>
                                    <Typography variant="subtitle2" fontWeight={"bold"}>
                                        {element.subject}
                                    </Typography>
                                </Stack>

                                <StatusTag code={element?.status} lang={language} version={version} />
                            </Stack>

                        </Grid>
                    </Grid>

                    <Stack direction={"row"} alignItems={"center"} spacing={1} mt={1}>
                        <Typography variant="subtitle2" >
                            {dict.Date_Create_Defect_TXT[language]} :
                        </Typography>
                        <Typography variant="subtitle2" fontWeight={"bold"} >
                            {moment(element.issue_date).format("DD/MM/YYYY")}
                        </Typography>
                    </Stack>

                    <Stack direction={"row"} spacing={1} justifyContent={"center"} mt={2}>
                         <Box sx={{ position: "relative" }}>
                            <BoxCoverChip>
                                <Chip label={"Before"} color="error" />
                            </BoxCoverChip>

                            <BoxHaveImg>
                                <ImageWithZoom
                                    src={element?.photos?.before_photo !== null ? element?.photos?.before_photo?.file_url : logoNoImage}
                                    alt={element?.photos?.before_photo?.file_id}
                                />
                            </BoxHaveImg>
                        </Box>
                        <Box sx={{ position: "relative" }}>
                            <BoxCoverChip>
                                <Chip label={"After"} color="success" />
                            </BoxCoverChip>

                            <BoxHaveImg >
                                <ImageWithZoom
                                    src={element?.photos?.after_photo !== null ? element?.photos?.after_photo?.file_url : logoNoImage}
                                    alt={element?.photos?.after_photo?.file_id}
                                />
                            </BoxHaveImg>
                        </Box>

                    </Stack>
                    <Stack direction="row"
                        justifyContent="center"
                        mt={2}
                    >
                        <Button size="large"
                            onClick={() => handleClickDetail(element.defect_id)}
                            sx={{ borderRadius: "10px", boxShadow: "0px 0px 7px 0px #00000040", width: "100%" }}>
                            {dict.More_TXT[language]}
                        </Button>
                    </Stack>
                </CardContent>
            </Card>
        }


        return <Card sx={{ minWidth: 275, borderRadius: "10px", boxShadow: "0px 0px 7px 0px #00000040" }}>
            <CardContent >
                <Stack direction="column"
                    spacing={1}
                >
                    <Typography fontSize={20} fontWeight={700} >
                        {element.subject}
                    </Typography>

                    <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={2}>
                        <Typography variant="caption" >
                            {dict.Status_TXT[language]}
                        </Typography>
                        <StatusTag code={element?.status} lang={language} version={version} />
                    </Stack>
                    <Stack direction={"row"} justifyContent={"space-between"} alignItems={"center"} spacing={2}>
                        <Typography variant="caption" >
                            {dict.Date_Create_Defect_TXT[language]}
                        </Typography>
                        <Typography fontSize={12} fontWeight={700} >
                            {moment(element.issue_date).format("DD/MM/YYYY")}
                        </Typography>
                    </Stack>
                </Stack>
                <Stack direction="row"
                    justifyContent="center"
                    mt={2}
                >
                    <Button size="large"
                        onClick={() => handleClickDetail(element.defect_id)}
                        sx={{ borderRadius: "10px", boxShadow: "0px 0px 7px 0px #00000040", width: "215.44px" }}>
                        {dict.More_TXT[language]}
                    </Button>
                </Stack>
            </CardContent>
        </Card>
    }

    return (
        conditionSelectCardDefect()
    )
}

const BoxHaveImg = styled(Box)(({ theme }) => ({
    [theme.breakpoints.up("md")]: {
        width: "150px",
        height: "150px"
    },
    [theme.breakpoints.down("md")]: {
        width: "25vw",
        height: "25vw"
    },
    // background: `linear-gradient(to right, ${theme.palette.primary.main} 100%, transparent 0%) top repeat-x , linear-gradient(${theme.palette.primary.main} 100%, transparent 60%) right repeat-y, linear-gradient(to right, ${theme.palette.primary.main} 1000%, transparent 0%) bottom repeat-x, linear-gradient(${theme.palette.primary.main} 100%, transparent 0%) left repeat-y`,
    // backgroundSize: "20% 3px,3px 20%",
    borderRadius: "5%",
    border: "1px solid",
    overflow: "hidden"
}))

const BoxCoverChip = styled(Box)(({ theme }) => ({
    position: "absolute",
    top: "-15px",
    left: "-5px",
    zIndex: 1
}))